@if(overlay()?.open){
<ng-container *ngComponentOutlet="overlay()?.component; inputs: overlay()?.inputs" />
}
